module.exports = __webpack_public_path__ + "static/IMG_20200718_132619-8e6025565d0d9e398b54fa2729a92763.jpg";